import { useMemo } from "react";
import { cn } from "web-design-system";
import { AmcLogo } from "./amc-logo";
import { sizeVariants } from "../avatars/avatar-client";

type AnyTypeWithAmcId =
  | { provider_company_id: string }
  | { amc_morning_star_code: string }
  | { morningstar_amc_code: string }
  | { amc_code: string }
  | { amc_morningstar_code: string };

function getCode(i: AnyTypeWithAmcId): string {
  if ("amc_code" in i) return i.amc_code;
  if ("amc_morningstar_code" in i) return i.amc_morningstar_code;
  if ("amc_morning_star_code" in i) return i.amc_morning_star_code;
  if ("morningstar_amc_code" in i) return i.morningstar_amc_code;
  return i.provider_company_id;
}

export function AmcLogoGroup(props: {
  items: AnyTypeWithAmcId[];
  displayCount?: number;
  hideDisplayCount?: boolean;
  size?: "xs" | "sm" | "lg" | "md";
}) {
  const hideDisplayCount = props.hideDisplayCount || false;
  const displayCount = props.displayCount || 3;

  const size = props.size || "default";

  const logos = useMemo(
    () => Array.from(new Set(props.items.map(getCode))).slice(0, displayCount),
    [props.items, displayCount]
  );

  const remainingFunds = props.items.length - logos.length;

  return (
    <div className="-space-x-1.5 flex flex-row">
      {logos.map((logo) => (
        <AmcLogo
          className="border border-border/50"
          key={logo}
          size={size}
          amc_code={logo}
        />
      ))}
      {!hideDisplayCount && remainingFunds > 0 ? (
        <span
          className={cn(
            sizeVariants({ size }),
            "z-1 border border-border bg-background flex items-center text-muted-foreground text-sm justify-center"
          )}
        >
          +{remainingFunds}
        </span>
      ) : null}
    </div>
  );
}
